import { getPrice } from "utils/getPrice";

export const thisOrderSavingsText = (
  memberSavings: number,
  currencySymbol: string
): string => `You’re saving <strong>${getPrice(
  memberSavings,
  currencySymbol
)}</strong> on
this order alone`;

export const savingsTodayText = (
  savingsToday: number,
  currencySymbol: string
): string =>
  `Savings today <strong>${getPrice(savingsToday, currencySymbol)}</strong>`;

export const savingsToDateText = (
  savingsToDate: number,
  currencySymbol: string
): string =>
  `Savings to date <strong>${getPrice(savingsToDate, currencySymbol)}</strong>`;

export const remainingSpendingLimitText = (
  remainingLimit: number,
  currencySymbol: string
): string =>
  `Remaining spending limit <strong>${getPrice(
    remainingLimit,
    currencySymbol
  )}</strong>`;
